import { cva } from 'class-variance-authority';

export const quoteContainer = cva(
  [
    'flex max-w-[800px] flex-col items-start gap-6 rounded-lg  border-[1.5px] border-solid border-primary-300 p-6 text-white sm:gap-8 sm:p-8',
  ],
  {
    variants: {
      color: {
        green: ['bg-primary-50 text-primary-900'],
      },
    },
    defaultVariants: {
      color: 'green',
    },
  },
);
